import React, { useState } from 'react';
type PlanId = 'basico' | 'completo';
const plans: {
  id: PlanId;
  badge?: string;
  icon: string;
  title: string;
  subtitle: string;
  ideal: string;
  oldPrice: string;
  price: string;
  highlight?: boolean;
  expandable?: {
    label: string;
    purpose: string;
    content: string;
  };
}[] = [{
  id: 'basico',
  icon: '📕',
  title: 'PACK ESENCIAL',
  subtitle: 'Tomo I + Tomo II + 3 Bonos',
  ideal: 'Ideal para: empezar con la base del control',
  oldPrice: '$39.999',
  price: '$19.999 ARS'
}, {
  id: 'completo',
  badge: '⭐ MÁS ELEGIDO',
  icon: '🏆',
  title: 'PACK COMPLETO + PLACER SAGRADO',
  subtitle: 'Tomo I + Tomo II + 3 Bonos + El Mapa del Placer Sagrado + 2 Bonos extra',
  ideal: 'Ideal para: dominio total del sistema',
  oldPrice: '$63.499',
  price: '$29.999 ARS',
  highlight: true,
  expandable: {
    label: '¿Qué incluye El Mapa del Placer Sagrado?',
    purpose: 'Que ella llegue al clímax antes, durante y después.',
    content: 'Zonas erógenas ocultas, el mapa del punto G/U/K, y cómo sincronizar tu nuevo control con sus picos de placer.'
  }
}];
export function PricingCTA() {
  const [selected, setSelected] = useState<PlanId>('completo');
  const [expanded, setExpanded] = useState<PlanId | null>(null);
  return <section className="pt-[28px] px-5 pb-[40px] text-center bg-gradient-to-b from-[#0a0a0a] via-[#120000] to-[#0a0a0a]" id="comprar" data-id="element-137">
      <div className="max-w-[680px] mx-auto px-2" data-id="element-138">
        <h2 className="font-montserrat font-black text-[clamp(1.5rem,4vw,2.2rem)] text-brand-white uppercase mb-2 leading-[1.15]" data-id="element-139">
          ELEGÍ TU <span className="text-brand-red" data-id="element-140">SISTEMA</span>
        </h2>
        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mt-[10px] mb-[22px] rounded-[2px]" data-id="element-141"></div>

        <div className="flex flex-col gap-3" data-id="element-142">
          {plans.map(plan => {
          const isSelected = selected === plan.id;
          return <button type="button" key={plan.id} onClick={() => setSelected(plan.id)} aria-pressed={isSelected} className={`relative text-left w-full rounded-[12px] p-[22px_16px] sm:p-[26px_20px] transition-all duration-300 border-2 ${isSelected ? 'border-brand-red bg-brand-black-card shadow-[0_0_40px_rgba(204,0,0,0.3)]' : 'border-[#222] bg-brand-black-card hover:border-[#3a3a3a]'}`} data-id="element-143">
                {plan.badge && <span className="absolute -top-2.5 right-3 bg-brand-gold text-black font-montserrat text-[0.6rem] font-extrabold tracking-[1.5px] uppercase py-0.5 px-2.5 rounded-full shadow-[0_4px_15px_rgba(201,168,76,0.4)]" data-id="element-144">
                    {plan.badge}
                  </span>}

                {/* Header row: radio + icon + title + price */}
                <div className="flex items-start gap-2.5 sm:gap-3" data-id="element-145">
                  {/* Radio */}
                  <div className={`flex-shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'border-brand-red' : 'border-[#444]'}`} data-id="element-146">
                    {isSelected && <span className="w-2.5 h-2.5 rounded-full bg-brand-red block" data-id="element-147"></span>}
                  </div>

                  {/* Icon */}
                  <div className="flex-shrink-0 text-lg sm:text-xl leading-none mt-0.5" data-id="element-148">
                    {plan.icon}
                  </div>

                  {/* Title */}
                  <div className="flex-1 min-w-0" data-id="element-149">
                    <h3 className="font-montserrat font-black text-brand-white uppercase tracking-[0.3px] text-[0.78rem] sm:text-[0.85rem] leading-[1.15] break-words" data-id="element-150">
                      {plan.title}
                    </h3>
                  </div>

                  {/* Price */}
                  <div className="flex-shrink-0 text-right" data-id="element-151">
                    <div className="font-montserrat text-[0.65rem] sm:text-[0.7rem] text-[#3a3a3a] line-through leading-tight" data-id="element-152">
                      {plan.oldPrice}
                    </div>
                    <div className={`font-montserrat font-black text-[0.9rem] sm:text-[1.1rem] leading-tight whitespace-nowrap ${plan.highlight ? 'text-brand-red' : 'text-brand-white'}`} data-id="element-153">
                      {plan.price}
                    </div>
                  </div>
                </div>

                {/* Details below */}
                <div className="mt-3.5 pl-[30px] sm:pl-[42px]" data-id="element-154">
                  <p className="font-opensans text-[0.72rem] text-brand-gray-text leading-[1.5] mb-1.5" data-id="element-155">
                    {plan.subtitle}
                  </p>
                  <p className="font-montserrat text-[0.68rem] font-bold text-brand-gold leading-[1.4]" data-id="element-156">
                    {plan.ideal}
                  </p>

                  {plan.expandable && <div className="mt-2.5" data-id="element-157">
                      <span role="button" tabIndex={0} onClick={e => {
                  e.stopPropagation();
                  setExpanded(expanded === plan.id ? null : plan.id);
                }} onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    setExpanded(expanded === plan.id ? null : plan.id);
                  }
                }} aria-expanded={expanded === plan.id} className="inline-flex items-center gap-1.5 font-montserrat text-[0.68rem] font-bold text-brand-red uppercase tracking-[0.5px] cursor-pointer hover:text-white transition-colors" data-id="element-158">
                        <span className={`inline-block transition-transform duration-300 ${expanded === plan.id ? 'rotate-90' : ''}`} data-id="element-159">
                          ▸
                        </span>
                        {plan.expandable.label}
                      </span>

                      <div className={`grid transition-all duration-300 ease-out ${expanded === plan.id ? 'grid-rows-[1fr] opacity-100 mt-2' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-160">
                        <div className="overflow-hidden" data-id="element-161">
                          <div className="border-l-2 border-brand-red/60 pl-3 py-1 bg-black/30 rounded-r-md" data-id="element-162">
                            <p className="font-opensans text-[0.7rem] text-brand-white leading-[1.5] mb-1.5" data-id="element-163">
                              <span className="font-montserrat font-bold text-brand-gold uppercase tracking-[0.5px] text-[0.62rem] block mb-0.5" data-id="element-164">
                                Propósito
                              </span>
                              {plan.expandable.purpose}
                            </p>
                            <p className="font-opensans text-[0.7rem] text-brand-gray-text leading-[1.5]" data-id="element-165">
                              <span className="font-montserrat font-bold text-brand-gold uppercase tracking-[0.5px] text-[0.62rem] block mb-0.5" data-id="element-166">
                                Contenido
                              </span>
                              {plan.expandable.content}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>
              </button>;
        })}
        </div>

        <a href={selected === 'completo' ? 'https://pagos.indigo33.shop/cart/63616699203953:1' : 'https://pagos.indigo33.shop/cart/63616690291057:1'} className="mt-5 block w-full bg-gradient-to-br from-brand-red to-brand-red-dark text-white font-montserrat font-black text-[clamp(0.85rem,2.5vw,1.05rem)] uppercase tracking-[1.2px] py-3.5 px-5 rounded-lg cursor-pointer transition-all duration-300 shadow-[0_8px_30px_rgba(204,0,0,0.45)] relative overflow-hidden hover:-translate-y-[3px] hover:shadow-[0_14px_45px_rgba(204,0,0,0.65)] before:content-[''] before:absolute before:top-0 before:-left-full before:w-full before:h-full before:bg-gradient-to-r before:from-transparent before:via-[rgba(255,255,255,0.12)] before:to-transparent before:transition-[left] before:duration-500 hover:before:left-full" data-id="element-167">
          → QUIERO EL{' '}
          {selected === 'completo' ? 'PACK COMPLETO' : 'PACK ESENCIAL'}
        </a>

        <div className="flex justify-center gap-x-4 gap-y-1.5 mt-3 flex-wrap" data-id="element-168">
          <div className="text-[0.78rem] text-[#666] font-montserrat flex items-center gap-[5px]" data-id="element-169">
            🔒 Pago seguro
          </div>
          <div className="text-[0.78rem] text-[#666] font-montserrat flex items-center gap-[5px]" data-id="element-170">
            📲 Acceso inmediato
          </div>
          <div className="text-[0.78rem] text-[#666] font-montserrat flex items-center gap-[5px]" data-id="element-171">
            🛡️ Garantía 30 días
          </div>
          <div className="text-[0.78rem] text-[#666] font-montserrat flex items-center gap-[5px]" data-id="element-172">
            📱 Funciona en celular
          </div>
        </div>
      </div>
    </section>;
}